export default __webpack_public_path__ + "static/media/broccoli.c2f45c21.svg";